import { Component, ViewChild, ViewEncapsulation, Renderer2, NgZone, OnDestroy, OnInit } from '@angular/core';
import { GlobalsService } from '../../shared/services/globals.service';
import { Subscription, Subject, fromEvent } from 'rxjs';
import { SelectionEvent, GridComponent, RowClassArgs, GridDataResult, PageChangeEvent, SelectableSettings } from '@progress/kendo-angular-grid';
import { filterBy, CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { InventoryService } from '../../shared/services/inventory.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { BaseAppMComponent } from '../../shared/base-components/base-app-m.component';
import { InventoryBus } from '../../shared/models/InventoryBus';
import { v_WarehousePartsBus } from '../../shared/models/v_WarehousePartsBus';
import { CommonFunctions } from '../../shared/static/common-functions';
import { take, takeUntil, tap } from 'rxjs/operators';
import * as _ from 'lodash';
import { InventoryTransferBus } from '../../shared/models/InventoryTransferBus';
import { BaseMessageInfo } from '../../shared/models/BaseMessageInfo';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { InventoryTransferAllBus } from '../../shared/models/InventoryTransferAllBus';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { GItem } from '@app/cp/shared/models/GItem';
import { UseCPLoader, ICPLoader } from '@app/cp/shared/decorators/cploader/cploader-decorator';
import { CPSearchComponent } from '../../shared/search/cp-search/cp-search.component';
import { OrderService } from '../../shared/services/order.service';
import { CommonValues } from '../../shared/static/CommonValues';

@UseCPLoader()
@Component({
    selector: 'warehouse-transfer',
    templateUrl: './warehouse-transfer.component.html',
    styleUrls: ['./warehouse-transfer.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class WarehouseTransferComponent extends BaseAppMComponent<InventoryBus, InventoryService, null, null> implements OnDestroy, OnInit {
    compLoader: ICPLoader = this as any;
    svc_order: OrderService;
    constructor(globals: GlobalsService,
        _qry_rd: DQOIReferenceDataQuery,
        _svc_data: InventoryService,
        _svc_order: OrderService,
        featureFlagService: FeatureFlagService,
        private renderer: Renderer2,
        private zone: NgZone,
        private sanitizer: DomSanitizer
    ) {
        super(globals, featureFlagService, _qry_rd);
        this.svc_data = _svc_data;
        this.svc_order = _svc_order;
    }
    public gridView1: GridDataResult;
    public gridView2: GridDataResult;
    public searchFilter1: string;
    public searchFilter2: string;
    public pageSize = 100;
    public skip1 = 0;
    public skip2 = 0;
    loading1 = false;
    loading2 = false;
    minLimit = 1;
    maxLimit = null;
    isStaging = false;
    gridDataOne: any[];
    gridDataTwo: any[];
    warehouse1: string;
    warehouse2: string;
    warehouse1Name: string;
    warehouse2Name: string;
    warehouse1IsMain: boolean = false;
    warehouse2IsMain: boolean = false;
    partSearch1: string;
    partSearch2: string;
    transferToId: string;
    transferFromId: string;
    showTransfer: boolean = false;
    showTransferAll: boolean = false;
    showTransferAllConfirmTwice: boolean = false;
    qtyTransfer: number = 0;
    rowg1: number;
    rowg2: number;
    selectedItem: v_WarehousePartsBus;
    warehouseParts1: v_WarehousePartsBus[];
    warehouseParts2: v_WarehousePartsBus[];
    warehousePartsFiltered1: v_WarehousePartsBus[];
    warehousePartsFiltered2: v_WarehousePartsBus[];
    @ViewChild('grid1') protected grid1: GridComponent;
    @ViewChild('grid2') protected grid2: GridComponent;
    @ViewChild('cpSearchOrders') protected CpSearchOrder: CPSearchComponent;
    subs_data1: Subscription;
    subs_data2: Subscription;
    subs_partsOnOrder: Subscription;
    warehouses:GItem[] = [];
    private sub_refDatUpdated: Subscription;
    inProcessAll: boolean = false;
    public filter1: CompositeFilterDescriptor;
    public filter2: CompositeFilterDescriptor;
    selectedDataGrid1: v_WarehousePartsBus;
    selectedDataGrid2: v_WarehousePartsBus;
    grid_Height: number = 649;
    grid_LineCount: number = 30;

    private destroy1$ = new Subject();
    private destroy2$ = new Subject();
    private currentSubscription1: Subscription;
    private currentSubscription2: Subscription;
    public selectableSettings: SelectableSettings = {
        checkboxOnly: false,
        mode: "single"
    };

    public valueChange1(value: any): void {
        this.partSearch1 = "";
        this.warehouse1Name = this.referenceData.getWarehouse(value);
        this.warehouse1IsMain = this.warehouse1Name.includes("Main ", 0) || this.warehouse1 == "f396497c-b3c4-4937-9995-e7303a0148cb";
        this.getPartsWarehouse1(value);
    }

    public filterList1(searchStr: string) {
        var lcValue = searchStr.toLowerCase();
        if (lcValue.length == 0) {
            this.warehousePartsFiltered1 = this.warehouseParts1.filter(prop => prop.partNumber === prop.partNumber);
        }
        else {
            this.warehousePartsFiltered1 = this.warehouseParts1.filter(prop => prop.partNumber.toLowerCase().indexOf(lcValue) !== -1 || prop.partDescription.toLowerCase().indexOf(lcValue) !== -1 || prop.fullDescription.toLowerCase().indexOf(lcValue) !== -1);
        }
        this.skip1 = 0;
        this.loadParts1();
        this.getDragReady1();
        this.getDragReady2();
        this.searchFilter1 = lcValue;

    }

    public filterList2(searchStr: string) {
        var lcValue = searchStr.toLowerCase();
        if (lcValue.length == 0) {
            this.warehousePartsFiltered2 = this.warehouseParts2.filter(prop => prop.partNumber === prop.partNumber);
        }
        else {
            this.warehousePartsFiltered2 = this.warehouseParts2.filter(prop => prop.partNumber.toLowerCase().indexOf(lcValue) !== -1 || prop.partDescription.toLowerCase().indexOf(lcValue) !== -1 || prop.fullDescription.toLowerCase().indexOf(lcValue) !== -1);
        }
        this.skip2 = 0;
        this.loadParts2();
        this.getDragReady2();
        this.searchFilter2 = lcValue;
    }

    public onKeypressEvent1(event: any): void {
        var lcValue = event.target.value.toLowerCase();
        this.filterList1(lcValue);

    };
    public doPartCount(event: any): void {
     

    };
    orderSearch: boolean = false;
    ctrlOpenFlag: boolean = false;
    public doOrderSearch(e: any) {
        if (CommonFunctions.hasStringValue(e) && e === "CLEAR") {
            this.orderNumber = null;
            this.orderId = null;
        }
        else {
            this.ctrlOpenFlag = true;
            this.orderSearch = true;
            setTimeout(() => {
                this.CpSearchOrder.setSearchText(e);
            }, 500);
        }
    }
    closeCtrlOpenFlag: boolean = false;
    orderNumber: string = "";
    orderId: string = "";
    public orderSelected(value: any) {
        this.orderSearch = false;
        if (value != null) {
            this.orderNumber = value.OrderNumber;
            this.orderId = value.OrderId;
            this.getPartsOnOrder(this.orderId, this.selectedItem.inventoryId);
            this.setDirty();
        }
        this.closeCtrlOpenFlag = true;
    }
    public valueChange2(value: any): void {
        this.partSearch2 = "";
        this.warehouse2Name = this.referenceData.getWarehouse(value);
        this.warehouse2IsMain = this.warehouse2Name.includes("Main ") || this.warehouse2 == "f396497c-b3c4-4937-9995-e7303a0148cb";
        this.getPartsWarehouse2(value);
    }

    public onKeypressEvent2(event: any): void {
        var lcValue = event.target.value.toLowerCase();
        this.filterList2(lcValue);
    };

    public closeTransfer() {
        this.showTransfer = false;
    }

    public closeTransferAll() {
        this.showTransferAll = false;
        this.showTransferAllConfirmTwice = false;
    }

    public filterChange1(filter: CompositeFilterDescriptor): void {
        this.filter1 = filter;
    }

    public filterChange2(filter: CompositeFilterDescriptor): void {
        this.filter2 = filter;
        this.warehousePartsFiltered2 = filterBy(this.warehouseParts2, this.filter2);

    }

    public pageChange1(event: PageChangeEvent): void {
        this.skip1 = event.skip;
        this.loadParts1();
    }

    private loadParts1(): void {
        this.gridView1 = {
            data: this.warehousePartsFiltered1.slice(this.skip1, this.skip1 + this.pageSize),
            total: this.warehousePartsFiltered1.length
        };
    }
    public pageChange2(event: PageChangeEvent): void {
        this.skip2 = event.skip;
        this.loadParts2();
    }

    private loadParts2(): void {
        this.gridView2 = {
            data: this.warehousePartsFiltered2.slice(this.skip2, this.skip2 + this.pageSize),
            total: this.warehousePartsFiltered2.length
        };
    }

    saveTransfer() {
        this.inProcessAll = true;
        this.compLoader.cpLoaderOn();
        let busObj: InventoryTransferBus = new InventoryTransferBus();
        busObj.inventoryLocationXrefid = this.selectedItem.inventoryLocationXREFId;
        busObj.inventoryId = this.selectedItem.inventoryId;
        busObj.newInventoryLocationId = this.transferToId;
        busObj.quantity = this.qtyTransfer;
        busObj.orderId = this.orderId;
        CommonFunctions.unsubscribe(this.subs_save);
        this.subs_save = this.svc_data.saveInventoryTransfer(busObj).subscribe((data: BaseMessageInfo) => {
            this.compLoader.cpLoaderOff();
            if (!data.saveError) {
                this.getPartsWarehouse1(this.warehouse1);
                this.getPartsWarehouse2(this.warehouse2);
                this.showTransfer = false;
                this.saveSuccess();
            }
            else {
                this.saveError(data.message);
                this.compLoader.cpLoaderOff();
            }
            this.inProcessAll = false;
        });
    }
    
    confirmTransferAll() {
        this.showTransferAllConfirmTwice = true;
    }

    saveTransferAll() {
        this.inProcessAll = true;
        this.compLoader.cpLoaderOn();
        let busObj: InventoryTransferAllBus = new InventoryTransferAllBus();

        busObj.inventoryLocationToId = this.transferToId;
        busObj.inventoryLocationFromId = this.transferFromId;
        CommonFunctions.unsubscribe(this.subs_save);
        this.subs_save = this.svc_data.saveInventoryTransferAll(busObj).subscribe((data: BaseMessageInfo) => {
            this.inProcessAll = false;
            this.compLoader.cpLoaderOff();
            if (!data.saveError) {
                this.getPartsWarehouse1(this.warehouse1);
                this.getPartsWarehouse2(this.warehouse2);
                this.showTransferAll = false;
                this.showTransferAllConfirmTwice = false;
                this.saveSuccess();
            }
            else {
                this.saveError(data.message);
                this.compLoader.cpLoaderOff();
            }
        });
    }

    getPartsWarehouse1(inventoryLocationId: string) {
        CommonFunctions.unsubscribe(this.subs_data1);
        this.warehouseParts1 = [];
        this.loading1 = true;

        this.subs_data1 = this.svc_data.getWarehousePartsByWareHouse(inventoryLocationId).subscribe(data => {
            if (!data.saveError) {
                let arr = this.buildFIlteredPartsArray(data);
                this.selectedDataGrid1 = null;
                this.warehouseParts1 = arr;
                this.filterList1(this.partSearch1);
            }
            this.loading1 = false;

        });
    }

    private buildFIlteredPartsArray(data: BaseMessageInfo) {
        let arr = [];
        if (CommonFunctions.hasArrayElementValue(data.primaryReturn)) {
            const filteredData = data.primaryReturn.filter(f => f.stockQuantity != 0);
            for (let i = 0; i < filteredData.length; i++) {
                let busObj: v_WarehousePartsBus = new v_WarehousePartsBus(filteredData[i]);
                arr.push(busObj);
            }
        }
        return arr;
    }
    maxParts = -1;
    minParts = 0;
    getPartsOnOrder(orderId: string, inventoryId: string) {
        CommonFunctions.unsubscribe(this.subs_partsOnOrder);
        this.maxParts = -1;
        this.subs_partsOnOrder = this.svc_order.getOrderDetailsByPart(orderId, inventoryId).subscribe(data => {
            if (CommonFunctions.hasArrayElementValue(data)) {
                this.maxParts = data.reduce((total, item) => {
                    const qty = item.quantity ?? 0;
                    const ratio = item.ratio ?? 1;
                    return total + (qty * ratio);
                }, 0);

                this.maxLimit = this.maxParts;
            }

        });
        

    }
    getPartsWarehouse2(inventoryLocationId: string) {
        CommonFunctions.unsubscribe(this.subs_data2);
        this.warehouseParts2 = [];
        this.loading2 = true;
        this.subs_data2 = this.svc_data.getWarehousePartsByWareHouse(inventoryLocationId).subscribe(data => {
            if (!data.saveError) {
                let arr = this.buildFIlteredPartsArray(data);
                this.selectedDataGrid2 = null;
                this.warehouseParts2 = arr;
                this.filterList2(this.partSearch2);
            }
            this.loading2 = false;

        });
    }

    buttonTansfer1To2() {
        this.displayTansferModal(this.selectedDataGrid1, this.warehouse2);
    }
    
    rowSelectedGrid1(e: SelectionEvent) {
        this.selectedDataGrid1 = e.selectedRows[0].dataItem;
    }
    buttonTansfer2To1() {

        this.displayTansferModal(this.selectedDataGrid2, this.warehouse1);
    }
    
    rowSelectedGrid2(e: SelectionEvent) {
        this.selectedDataGrid2 = e.selectedRows[0].dataItem;
    }

    displayTansferModal(si: v_WarehousePartsBus, transferToId: string) {
        this.inProcessAll = false;
        if (si && transferToId) {
            this.isStaging = (CommonValues.InventoryLocation_StagingWarehouse == si.inventoryLocationId && this.featureFlagService.latestFeatureFlagSet['ui-require-po-selection-on-from-staging-warehouse-transfers']);
            this.maxLimit = null;
            this.maxParts = -1;
            this.orderId = null
            this.orderNumber = null;
            this.showTransfer = true;            
            this.selectedItem = si;
            this.transferToId = transferToId;
            this.qtyTransfer = 0;
        }
    }
    displayTansferModalAll(transferFromId: string, transferToId: string) {
        this.isStaging = (CommonValues.InventoryLocation_StagingWarehouse == transferFromId);
        this.showTransferAll = true;
        this.maxLimit = null;
        this.maxParts = -1;
        this.orderId = null
        this.orderNumber = null;
        this.transferFromId = transferFromId;
        this.transferToId = transferToId;
        this.inProcessAll = false;
    }
    
    override ngOnInit(): void {
        super.ngOnInit();
        this.sub_refDatUpdated = this.qry_rd.referenceDataUpdated.subscribe((refdata: DQOIReferenceData) => {
            this.warehouses = refdata?.warehouses ?? [];
        });
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
        CommonFunctions.unsubscribe(this.currentSubscription1);
        CommonFunctions.unsubscribe(this.currentSubscription2);
        CommonFunctions.unsubscribe(this.subs_data1);
        CommonFunctions.unsubscribe(this.subs_data2);
        CommonFunctions.unsubscribe(this.sub_refDatUpdated);
    }
    
    tableRow = node => (node.tagName && node.tagName.toLowerCase() === 'tr');

    closest = (node, predicate) => {
        while (node && !predicate(node)) {
            node = node.parentNode;
        }

        return node;
    };

    getDragReady1() {

        if (this.currentSubscription1) {
            var subs = this.currentSubscription1;
            if (this.destroy1$) {
                this.destroy1$.next('TODO: BILL LOOK AT THIS');
                this.destroy1$.complete();
            }
            this.destroy1$ = new Subject();
            this.currentSubscription1.unsubscribe();
        }
        this.zone.onStable.pipe(take(1))
            .subscribe(() => this.currentSubscription1 = this.handleDragAndDrop1());
    }

    handleDragAndDrop1(): Subscription {

        const sub = new Subscription(() => { });

        let draggedItemIndex;
        let dropItemIndex;
        let remoteDropItemIndex;
        let droplocation;
        let overCnt: number = 0;
        var inEditMode = "true";
        if (this.editForm) { inEditMode = "false"; }
        const tableRows = Array.from(document.querySelectorAll('div.wt1GridDiv > .k-grid tr'));
        const table = Array.from(document.querySelectorAll('div.wt1GridDiv '));
        const dragOverT = fromEvent(table, 'dragover');
        const dragLeaveT = fromEvent(table, 'dragleave');
        sub.add(dragLeaveT.pipe(takeUntil(this.destroy1$)).subscribe((e: any) => {
            const row: HTMLTableRowElement = <HTMLTableRowElement>e.target;
            remoteDropItemIndex = null;
            dropItemIndex = null;
        }));
        sub.add(dragOverT.pipe(takeUntil(this.destroy1$)).subscribe((e: any) => {
            e.preventDefault();
            const row: HTMLTableRowElement = <HTMLTableRowElement>e.target;
            const dropIndex = 99;
            this.rowg1 = dropIndex;
            remoteDropItemIndex = dropIndex;
            if (dropItemIndex == dropIndex) { dropItemIndex = null; }
            this.zone.run(() => { var a = 1; }
            );
        }));

        tableRows.forEach(item => {
            this.renderer.setAttribute(item, 'draggable', 'true');
            const dragStart = fromEvent<DragEvent>(item, 'dragstart');
            const dragEnd = fromEvent(item, 'dragend');
            var dataItem;
            sub.add(dragStart.pipe(
                tap(({ dataTransfer }) => {
                    try {
                        // Firefox won't drag without setting data
                        dataTransfer.setData('application/json', "");
                    } catch (err) {
                        // IE doesn't support MIME types in setData
                    }
                })
            ).pipe(takeUntil(this.destroy1$)).subscribe(({ target }) => {
                const row: HTMLTableRowElement = <HTMLTableRowElement>target;
                draggedItemIndex = row.rowIndex;
                var data = _.cloneDeep(this.grid1.data);
                dataItem = data.data[draggedItemIndex];
            }));

            sub.add(dragEnd.pipe(takeUntil(this.destroy1$)).subscribe((e: any) => {
                e.preventDefault();
                if (this.rowg2 > -1 || this.rowg2 == -2) {
                    this.zone.run(() => {
                        this.displayTansferModal(dataItem, this.warehouse2);
                    });
                }
            }));
        });

        return sub;
    }

    getDragReady2() {

        if (this.currentSubscription2) {
            var subs = this.currentSubscription2;
            if (this.destroy2$) {
                this.destroy2$.next('TODO: BILL LOOK AT THIS');
                this.destroy2$.complete();
            }
            this.destroy2$ = new Subject();
            this.currentSubscription2.unsubscribe();
        }
        this.zone.onStable.pipe(take(1))
            .subscribe(() => this.currentSubscription2 = this.handleDragAndDrop2());
    }

    handleDragAndDrop2(): Subscription {

        const sub = new Subscription(() => { });
        let draggedItemIndex;
        let dropItemIndex;
        let remoteDropItemIndex;
        var inEditMode = "true";
        if (this.editForm) { inEditMode = "false"; }
        const tableRows = Array.from(document.querySelectorAll('div.wt2GridDiv > .k-grid tr'));
        const table = Array.from(document.querySelectorAll('div.wt2GridDiv '));
        const dragOverT = fromEvent(table, 'dragover');
        const dragLeaveT = fromEvent(table, 'dragleave');
        sub.add(dragLeaveT.pipe(takeUntil(this.destroy1$)).subscribe((e: any) => {
            const row: HTMLTableRowElement = <HTMLTableRowElement>e.target;
            remoteDropItemIndex = null;
            dropItemIndex = null;
        }));

        sub.add(dragOverT.pipe(takeUntil(this.destroy1$)).subscribe((e: any) => {
            e.preventDefault();
            const row: HTMLTableRowElement = <HTMLTableRowElement>e.target;
            const dropIndex = 99;

            this.rowg2 = dropIndex;
            remoteDropItemIndex = dropIndex;
            if (dropItemIndex == dropIndex) { dropItemIndex = null; }
            this.zone.run(() => { var a = 1; }
            );
        }));

        tableRows.forEach(item => {
            this.renderer.setAttribute(item, 'draggable', 'true');
            const dragStart = fromEvent<DragEvent>(item, 'dragstart');
            const dragOver = fromEvent(item, 'dragover');
            const dragEnd = fromEvent(item, 'dragend');
            const dragLeave = fromEvent(item, 'dragleave');
            var dropItemIndex;
            var dataItem;
            sub.add(dragStart.pipe(
                tap(({ dataTransfer }) => {
                    try {
                        // Firefox won't drag without setting data
                        dataTransfer.setData('application/json', "");
                    } catch (err) {
                        // IE doesn't support MIME types in setData
                    }
                })
            ).pipe(takeUntil(this.destroy2$)).subscribe(({ target }) => {
                const row: HTMLTableRowElement = <HTMLTableRowElement>target;
                draggedItemIndex = row.rowIndex;
                var data = _.cloneDeep(this.grid2.data);
                dataItem = data.data[draggedItemIndex];
            }));

            sub.add(dragEnd.pipe(takeUntil(this.destroy2$)).subscribe((e: any) => {

                if (this.rowg1 > -1 || this.rowg1 == -2) {
                    this.zone.run(() => {
                        this.displayTansferModal(dataItem, this.warehouse1);
                    });
                }
            }));
        });

        return sub;
    }

    public colorCode(warehouseParts: v_WarehousePartsBus): SafeStyle {
        let result = "transparent";
        if (warehouseParts.maxThreshold > 0 && warehouseParts.maxThreshold < warehouseParts.stockQuantity) { result = "#FFBA80"; }
        if (warehouseParts.minThreshold > 0 && warehouseParts.minThreshold > warehouseParts.stockQuantity) { result = "#B2F699"; }
        return this.sanitizer.bypassSecurityTrustStyle(result);
    }

    rowClassFunction(context: RowClassArgs) {
        let data: any = context.dataItem;
        let rowClass = {};

        if (data.maxThreshold > 0 && data.maxThreshold < data.stockQuantity) {
            rowClass = { over: true };
        }
        if (data.minThreshold > 0 && data.minThreshold > data.stockQuantity) {
            rowClass = { under: true };
        }
        return rowClass;
    }

    get gridData_Length(): number {
        return CommonFunctions.hasArrayElementValue(this.gridView1) ? this.gridView1.data.length : 0;
    }

    get gridLength(): number {
        //TODO BW: set up height for responsive screens.
        return this.gridData_Length > this.grid_LineCount ? this.grid_Height : null;
    }
}
